import { forwardRef } from 'react';
import { Input } from 'reactstrap';

export const Radio = forwardRef((props, ref) => {
  return <Input type="radio" innerRef={ref} {...props} />;
});
